import React, { useEffect } from "react";

import { OrganizationFeatures } from "providers/OrganizationFeatures";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";
import Help from "ui/Help";
import LoadingErrorBoundary from "ui/LoadingErrorBoundary";
import OutdatedCollectorNotice from "frame/OutdatedCollectorNotice";
import WebsocketUnhealthy from "frame/WebsocketUnhealthy";
import PageSideNav from "frame/PageSideNav";
import StatusNotice from "frame/StatusNotice";
import WarnIfPastDue from "frame/WarnIfPastDue";
import WarnIfSamlCertExpiring from "frame/WarnIfSamlCertExpiring";
import WarnIfServerOverage from "frame/WarnIfServerOverage";

import styles from "frame/PageLayout/style.module.scss";
import { useUserPreferences } from "utils/hooks";

type Props = {
  content: React.ReactNode;
};

const PageLayout: React.FunctionComponent<Props> = ({ content }) => {
  const { id, slug } = useCurrentOrganization(true) ?? {};
  const [lastVisited, setLastVisited] = useUserPreferences("lastVisitedOrg");
  useEffect(() => {
    if (id && slug && (slug !== lastVisited.slug || !lastVisited.id)) {
      setLastVisited({ id, slug });
    }
  }, [id, slug, lastVisited, setLastVisited]);

  return (
    <OrganizationFeatures>
      <div className={styles.page}>
        <Help />
        <WarnIfPastDue />
        <WarnIfServerOverage />
        <WarnIfSamlCertExpiring />
        <StatusNotice />
        <OutdatedCollectorNotice />
        <WebsocketUnhealthy />
        <PageSideNav />
        <div className={styles.content}>
          <LoadingErrorBoundary>{content}</LoadingErrorBoundary>
        </div>
      </div>
    </OrganizationFeatures>
  );
};

export default PageLayout;
